// DAO interfaces for AREA datatypes
// Generated from https://transform.tools/json-to-typescript
import { FormBuilder, FormGroup } from '@angular/forms';

import { of } from 'rxjs';
import * as constants from './constants';
import { removeEmptyProperty, tofseformat, getDateStringFromYYYYMMDD, getDateFromYYYYMMDD, toFRformat, ProcessingResult } from '../shared/utils';
import * as daolots from './dao-lots';
import * as daorsp from './dao-rsp';
import { StateService } from '../shared/state.service';

// Mek data structures
export interface C_value {
  // Typical c_value data structure
  id: number;
  name?: string;
  seq?: number;
  data: any;
  is_active: boolean;
}

export interface ApiResponse<T = any> {
  success: boolean;
  msg?: string | null;
  data: T;
  error_code?: number | null;
  error_msg?: string | null;
}

export class Station {
  // C_STATION. WARNING cloned from
  id?: number;
  store?: number;
  name?: string;
  data?: any;
  lnk_store?: any;
}

export class Event {
  // WARNING Keep in sync w/ mek front
  id?: number;
  typ?: number;
  userid?: number;
  objecttyp?: number;
  objectid?: number;
  data?: any;
}

export class Patient {
  partner?: number;
  assure?: string;
  nir?: string;
  nom?: string;
  prenom?: string;
  datbirth?: string;
  orderbirth?: number;
  quality?: number;
  datacv?: any; // jsonb
}

export const jsonheader = { 'content-type': 'application/json' };
export const qualites$ = of({ id: 0, seq: 1, name: 'Assuré', is_active: true }, { id: 1, seq: 2, name: 'Ascendant, desc.', is_active: true }, { id: 2, seq: 3, name: 'Conjoint', is_active: true }, { id: 3, seq: 4, name: 'Conjoint divorcé', is_active: true }, { id: 4, seq: 5, name: 'Concubin', is_active: true }, { id: 5, seq: 6, name: 'Conjoint séparé', is_active: true }, { id: 6, seq: 7, name: 'Enfant', is_active: true }, { id: 8, seq: 8, name: 'Conjoint veuf', is_active: true }, { id: 9, seq: 9, name: 'Autre', is_active: true });

export type EtatFactureRSP = 'NO' | 'N' | 'S' | 'P' | 'R' | 'D' | 'C' | 'PF' | 'A'; // État de la facture/ de la partie (AMO/AMC) APRÉS RSPs :"No part" | "Nouvelle" | "Sécurisée" | "Payée" | "Rejeté" | "Différé" | "en Cours" | Anomalie
const EtatFactureRSPSet = new Set<EtatFactureRSP>(['NO', 'N', 'S', 'P', 'R', 'D', 'C', 'PF', 'A']);

export function isEtatFactureRSP(value: unknown): value is EtatFactureRSP {
  // Is value a valid state (in EtatFactureRSP)
  return typeof value === 'string' && EtatFactureRSPSet.has(value as EtatFactureRSP);
}
// FSE related persistence Interfaces

export class FSEOrder {
  // fse_order DTO
  id: number;
  id_order: number;
  id_batch?: number;
  etat_facture: string; // Final (normal processing) state is RSP. Set by extraire_lots
  type_facture: string;
  data: {
    factureFR: FactureFR;
    annulDRE: boolean;
    empreinteCV?: EmpreinteCV;
    empreinteADR?: EmpreinteAdr;
    contexteAuthentificationApCV?: ContexteAuthentificationApCV;
    index?: number; // Index of recipient in empreinteCV
    processingResult: ProcessingResult | undefined; // Last process result
    mode?: number;
  };
  lnk_batch_fse?: daolots.Batch;
  lnk_batch_dre?: daolots.Batch;
  lnk_docs?: FseDoc[];
  lnk_rsp_fses: daorsp.RSP[] = [];
  lnk_rsp_dres: daorsp.RSP[] = [];
  attach_icon: string | undefined; // NOT idiomatic in a DTO but allows for caching the value

  totalRemboursable?: number; // Derived values to flatten/precompute processingResult data
  totalDu?: number;
  remboursableAmo?: number;
  remboursableAmc?: number;
  payedAMO: number = 0;
  payedAMC: number = 0;
  duAmo?: number;
  duAmc?: number;
  orgAmc: string | undefined; // NumAMC or MUTNUM

  etatFactureRSP: [FSE: EtatFactureRSP, AMO: EtatFactureRSP, AMC: EtatFactureRSP] = ['C', 'C', 'C'];
  etatFactureRSPClass: string = ''; // Classe CSS de la ligne. Précalculé
  etatRSPFSEClass: string = ''; // Classe CSS du bouton DRE
  etatRSPDREClass: string = ''; // Classe CSS du bouton DRE

  constructor(id: number, id_order: number, id_batch: number | undefined, etat_facture: string, type_facture: string, factureFR: FactureFR, empreinteCV: EmpreinteCV | undefined, index: number | undefined, lnk_batch_fse: daolots.Batch | undefined, lnk_batch_dre: daolots.Batch | undefined, lnk_docs: FseDoc[] | undefined, lnk_rsp_fses: daorsp.RSP[], lnk_rsp_dres: daorsp.RSP[]) {
    this.id = id;
    this.id_order = id_order;
    this.id_batch = id_batch;
    this.etat_facture = etat_facture;
    this.type_facture = type_facture;
    this.data = {
      factureFR: factureFR,
      annulDRE: false,
      empreinteCV: empreinteCV,
      index: index,
      processingResult: undefined,
    };
    this.lnk_batch_fse = lnk_batch_fse;
    this.lnk_batch_dre = lnk_batch_dre;
    this.lnk_docs = lnk_docs;
    this.lnk_rsp_fses = lnk_rsp_fses;
    this.lnk_rsp_dres = lnk_rsp_dres;
  }
}

export interface FseDoc {
  id: number; // SERIAL PRIMARY KEY
  id_fse: number; // INTEGER NOT NULL, FK fse_order
  file_name: string; // TEXT NOT NULL, Uploaded file name
  nature: string; // TEXT NOT NULL, Nature de la pièce justificative
  idfactresponsable: string; // TEXT NOT NULL, Identifiant de facturation du PS qui a établi la PJ
  datcre: string; // TIMESTAMPTZ NOT NULL DEFAULT NOW(), Date de constitution (ISO string)
  typepj: string; // Format de la pièce justificative
  idpj?: string | null; // Identifiant de la PJ (nullable, obligatoire en entrée si type=REF_EXTERNE, interdit sinon)
  index_doc?: number | null; // INTEGER, N° d'ordre du dossier de PJ pour une facture donnée (nullable)
  reference?: string | null; // TEXT, Référence du dossier (PDF,PAPIER,REF_EXTERNE) (nullable)
  codeaction?: string | null; // TEXT, éventuelles interactions nécessaires pour ce dossier de PJ (nullable)
  etatdossier?: string | null; // TEXT, Etat du dossier de PJ (nullable)
  dateheureetatdossier?: string | null; // TEXT, Date du dernier changement d'état du dossier de PJ (nullable)
  diagnostic?: string | null; // TEXT, Diagnostic de l'éventuelle anomalie de transmission du dossier de PJ (nullable)
  content?: Buffer; // BYTEA, FILE content stored as binary data (nullable)
  content_base64?: string; // TEXT, FILE content stored as base64 (nullable)
}

// AreaFSE HTTP related interfaces

// ouvrirSession

export interface AreaResponseType {
  HTTPResponse: {
    codeRetour: string;
    libRetour: string;
    idSession: string;
    factureFR?: any; // Keep it untyped here, could vary a lot
  };
}

// LireCPS

export interface LireCPSResponse {
  HTTPResponse: LireCPSHTTPResponse;
}

export interface LireCPSHTTPResponse {
  codeRetour: number;
  libRetour: string;
  idSession: string;
  empreinteCPS: EmpreinteCPS;
}

export interface EmpreinteCPS {
  typeCarte: string;
  typeIdNat: string;
  numIdNat: string;
  codeCivilite: string;
  nomPS: string;
  prenomPS: string;
  situation: Situation[];
}

export interface Situation {
  numLogSituation: string;
  modeExercice: string;
  statutExercice: string;
  secteurActivite: string;
  typeIdentStruct: string;
  numIdentStruct: string;
  raisSocStruct: string;
  numIdentFact: string;
  codeConv: string;
  codeSpec: string;
  codeZoneTarif: string;
  codeZoneIK: string;
  codeAgr1: string;
  codeAgr2: string;
  codeAgr3: string;
  habSignFact: string;
  habSignLot: string;
}

// ParamPS

// https://codebeautify.org/xml-to-typescript-pojo-generator

export interface RecupererParamPS {
  HTTPResponse: ParamPSHTTPResponse;
}

export interface ParamPSHTTPResponse {
  codeRetour: string;
  libRetour: string;
  idSession: string;
  paramPS: ParamPS;
}

export interface ParamPS {
  numIdentFact: number;
  codeSpec: number;
  typeEmet: string;
  numEmet: number;
  mailFact: string;
  urlSMTP: string;
  portSMTP: number;
  sslSMTP: number; // Added based on XML model
  authSMTP: number;
  loginSMTP: string; // Added based on XML model
  urlPOP3: string;
  passSMTP: string; // Added based on XML model
  portPOP3: number;
  loginPOP3: string;
  passPOP3: string;
  topCompression: number;
  topChiffrement: number;
  topAffichDiagSTS: number;
  topDesactivSTS: number;
  topSupprimerNonSV: number;
  nbMaxFseParLot: number;

  modeFonc: string; // OCT
  numOCT: string;
  typeDestOCT: string;
  appliOCT: string;
  balOCT: string;

  modeSCOR: string;

  typeDestinaireARLSCOR: string;
  codeRegionSCOR: number;
  tailleMaxPDFSCOR: number;
  tailleMaxLotSCOR: number;
}

// LireCV

export interface LireCVResponse {
  HTTPResponse: LireCVHTTPResponse;
}

export interface LireCVHTTPResponse {
  codeRetour: number;
  libRetour: string;
  idSession: string;
  empreinteCV: EmpreinteCV;
}

export interface EmpreinteCV {
  topOpposition: string;
  topPartielle: string;
  typeCarte: string;
  numSerieCV: string;
  typeIdentPorteurCarte: string;
  numSecu: string;
  codeRegime: string;
  caisseGest: number;
  centreGest: number;
  codeGest: string;
  beneficiaire: Beneficiaire[];
  donneesAT: DonneesAT | undefined;
}

export interface Beneficiaire {
  // Partie Beneficiaire de EmpreinteCV
  nomUsuel: string | undefined;
  prenom: string | undefined;
  nomFamille: string | undefined;
  adresse1: string | undefined;
  adresse2: string | undefined;
  adresse3: string | undefined;
  adresse4: string | undefined;
  adresse5: string | undefined;
  numSecuCertif: string | undefined;
  dateCertifNumSecu: string | undefined;
  dateNaissance: string;
  rangNaissance: number;
  qualite: number;
  codeSrvAMOBenef: string | undefined; // situation spécifique: C2S, AME; ...
  dateDebSrvAMOBenef: string | undefined;
  dateFinSrvAMOBenef: string | undefined;
  topDeclarationMT: string | undefined;
  periodeDroitsAMO: PeriodeDroitsAMO[] | undefined;
  periodeCodeCouverture: PeriodeCodeCouverture[];
  donneesMutuelle: DonneesMutuelle | undefined;
  donneesAMC: DonneesAMC | undefined;
}

export interface DonneesAT {
  orgaGestRisqueAT: number;
  orgaGestAT1: number;
  idAT1: number;
  orgaGestAT2: number;
  idAT2: number;
}

export interface DonneesMutuelle {
  mutnum: string;
  garanties: string;
  indicTraitMutuelle: string;
  typeService: string;
  service: string;
  aiguillageSTS: string;
  periodeMutuelle: PeriodeMutuelle[];
}

export interface DonneesAMC {
  numAMC: string;
  numEDI: string;
  numAdherent: string;
  indicTraitAMC: string;
  typeService: string;
  service: string;
  aiguillageSTS: string;
  codeRoutage: string;
  idHote: string;
  domaine: string;
  dateDebut: string;
  dateFin: string;

  active?: boolean; // Derived field. Is situation active related to a reference date
}

export interface PeriodeCodeCouverture {
  codeALD: string;
  codeSituation: string;
  dateDebut: string;
  dateFin: string;
  active?: boolean; // Derived field. Is situation active related to a reference date
}

export interface PeriodeDroitsAMO {
  dateDebut: string;
  dateFin: string;
  active?: boolean; // Derived field. Is situation active related to a reference date
}

export interface PeriodeMutuelle {
  dateDebut: string;
  dateFin: string;
  active?: boolean; // Derived field. Is situation active related to a reference date
}

export enum ModeGestion {
  NONE, // Pas d'élément pour trancher => info from saisie PS
  GU, // Gestion Unique
  GS, // Gestion Séparée
}

export enum SituationSpecifique {
  NONE = 0, // Pas de situation spécifique

  // --- Situations liées au Professionnel de Santé ou à la facturation ---
  //SP02 = ?, // Professionnel de santé Remplaçant ou Multi-employeurs - Non géré par les fournisseus
  SP09 = 9, // Absence de support Vitale
  SP11 = 10, // Forçage
  SP12 = 11, // Professionnel de Santé utilisant les services d’un OCT
  //SP18 = 12,  // Victime d’attentat (Situation prioritaire sur les autres SP du bénéficiaire) => Devient un indicateur pour ne pas surcharger une situation sous-jacente (situation non exclusive)
  CFE = 13, // Caisse des Français de l'étranger. WARNING Pas strictment une situation spécifique

  // --- Situations liées au Bénéficiaire des Soins ---
  SP03a = 1, // Bénéficiaire de la C2S en GU (AMO)
  SP03b = 2, // Bénéficiaire de la C2S
  SP03c = 3, // Bénéficiaire de la C2S AMC / Pas de données AMC => GU ou TP coordonné
  SP03d = 4, // Bénéficiaire de la C2S
  SP04 = 5, // Bénéficiaire sortant de la C2S
  SP06 = 6, // Bénéficiaire de l’AME
  SP081 = 7, // Bénéficiaire Migrant de passage « BS de passage coordonné RSS »
  SP082 = 8, // "BS permanent coordonné RSS" ex « autre situation de migrant »
}

export const SituationSpecifiqueDescriptions: { [key in SituationSpecifique]: string } = {
  [SituationSpecifique.NONE]: 'Pas de situation spécifique',
  [SituationSpecifique.SP03a]: 'C2S gérée par le régime obligatoire', // SP03 = [RG_BS076][SP03] Spécifiques C2S
  [SituationSpecifique.SP03b]: 'C2S gérée par AMC conv. ou AMO',
  [SituationSpecifique.SP03c]: 'C2S gérée par AMC - Mode de gestion indeterminé\nÉventuelle attestation. compl. pour transmission directe',
  [SituationSpecifique.SP03d]: "Possibilité de C2S. Demander la présentation d'un justificatif",
  [SituationSpecifique.SP04]: 'Bénéficiaire sortant de C2S',
  [SituationSpecifique.SP06]: 'Bénéficiaire de l’AME',
  [SituationSpecifique.SP081]: 'Bénéficiaire Migrant de passage',
  [SituationSpecifique.SP082]: 'BS permanent coordonné RSS', // Ex "Bénéficiaire «autre situation de migrant»" FACT-SFG-012 BS [RG_BS314] [SP08.2],
  [SituationSpecifique.SP09]: 'Absence de support Vitale',
  [SituationSpecifique.SP11]: 'Forçage',
  [SituationSpecifique.SP12]: 'Professionnel de Santé utilisant les services d’un OCT',
  //[SituationSpecifique.SP18]: "Assuré victime d’attentat",
  [SituationSpecifique.CFE]: "Caisse des Français de l'Étranger",
};

export const SituationSpecifiquePrint: { [key in SituationSpecifique]: boolean[] } = {
  // [Print droits fermés ?, Print period]
  [SituationSpecifique.NONE]: [false, false], // WARNING always been true but why?
  [SituationSpecifique.SP03a]: [true, false],
  [SituationSpecifique.SP03b]: [true, false],
  [SituationSpecifique.SP03c]: [true, false],
  [SituationSpecifique.SP03d]: [true, false],
  [SituationSpecifique.SP04]: [true, false],
  [SituationSpecifique.SP06]: [true, false],
  [SituationSpecifique.SP081]: [true, false],
  [SituationSpecifique.SP082]: [true, true],
  [SituationSpecifique.SP09]: [true, false],
  [SituationSpecifique.SP11]: [true, false],
  [SituationSpecifique.SP12]: [true, false],
  //[SituationSpecifique.SP18]: [true, false],
  [SituationSpecifique.CFE]: [true, true],
};

export enum Nature {
  MALADIE,
  MATERNITE,
  AT, // Accidents du Travail
  SMG, // Soins Médicaux Gratuits
}

export type SituationNatures = [CV: SituationNature, ADR: SituationNature];

export class SituationNature {
  referenceDate: Date;
  pc?: PeriodeCodeCouverture; // Related to beneficiaire.periodeCodeCouverture
  codeRegime?: string; // == Empreinte[CV/ADR].codeRegime
  nature?: Nature; // Derived from PC by detection rules
  sp: SituationSpecifique; // Calculated by specificCasesDetection. Derived from codeSrvAMOBenef and co..
  isDroitsAMO: boolean = false; // Droits AMO actifs ? Not until find one voir aussi droits résultants (droitsOuverts)
  isALD: boolean = false; // ALD actifs ? Not until find one
  isAttentat: boolean = false; // Article 115, invalide de guerre / victime d'attentat
  activePeriodeAmoIndex?: number; // Index of active periodeDroitsAMO (should always be 0?)
  activePeriodeMutuelleIndex?: number; // Index of active AMC (Gestion unique).
  msgu: string = ''; // Message de gestion UNIQUE ou Séparée
  msgspe: string = ''; // Message de situation spécifique
  msgdebug: string = ''; // Mesage détail situation
  isDroitsOuverts: boolean = true; // Droit résultant. Peut venir de la période AMO ou de situations spécifiques. Seulement pour C2S, Migrant
  modeGestion: ModeGestion = ModeGestion.NONE; // Start w/ not determined OR special case SP03d

  constructor(
    referenceDate: Date,
    pc: PeriodeCodeCouverture | undefined,
    codeRegime: string | undefined,
    nature: Nature | undefined,
    sp: SituationSpecifique,
    activePeriodeMutuelleIndex?: number,
    msgu: string = '', // Message de gestion UNIQUE ou Séparée
    msgspe: string = '', // Message de situation spécifique
    msgdebug: string = '', // Mesage détail situation
  ) {
    this.referenceDate = referenceDate;
    this.pc = pc;
    this.codeRegime = codeRegime;
    this.nature = nature;
    this.sp = sp;
    this.activePeriodeMutuelleIndex = activePeriodeMutuelleIndex;
    this.msgu = msgu ? msgu : '';
    this.msgspe = msgspe ? msgspe : '';
    this.msgdebug = msgdebug ? msgdebug : '';
  }
}

// consulterADR

export interface ConsulterADRResponse {
  HTTPResponse: ADRHttpresponse;
}

export interface ADRHttpresponse {
  codeRetour: string;
  libRetour: string;
  idSession: string;
  empreinteADR: EmpreinteAdr;
}

export interface EmpreinteAdr {
  numSecu: string;
  codeRegime: string;
  caisseGest: string;
  centreGest: string;
  codeGest: string;
  donneesAT?: DonneesAT;
  beneficiaire: Beneficiaire;
}

// demanderContexteAuthentificationApCV

export interface demanderContexteAuthentificationApCVResponse {
  HTTPResponse: ContexteAuthentificationApCVResponse;
}

export interface ContexteAuthentificationApCVResponse {
  codeRetour: string;
  libRetour: string;
  idSession: string;
  contexteAuthentificationApCV: ContexteAuthentificationApCV;
}

export interface ContexteAuthentificationApCV {
  dateHeureFinValidite: string; // Horodatage de fin de validé du contexte. La durée de validité pourra dépendre de différents éléments comme la spécialité du PS
  idCtxtApCV: string; // Identifiant du Contexte d'Authentification ApCV
  tokenApCV: string; // Tokendu Contexte d'Authentification ApCV
  numSerieApCV: string; // Numéro de série de l'ApCV
  typeApCV: string; // Type d'Appli CV (R: réel / T: test / D: démo)
  versionApCV: string; // Numéro de version de l'ApCV
  individu: IndividuApCV | IndividuApCV[]; // Données ApCV d'un bénéficiiaire
}

export interface IndividuApCV {
  topUtilisateur: string; // Vaut 1 si les données sont celles de l'utilisateur de l'ApCV, sinon vaut 0
  nomFamille?: string;
  nomUsage?: string;
  prenom?: string;
  qualite: string; // Lien avec l’assuré
  dateNaissance: string; // AAAAMMJJ Avec 1⇐MM⇐99 et 1⇐JJ⇐99
  rangNaissance: string; // >1 pour les jumeaux, triplets, …
  numSecu: string; // Numéro de sécurité social de l’assuré + clé
  numSecuCertif?: string; // Numéro de sécurité sociale individuel certifié.
  codeRegime: string; // Régime dont dépend le patient
  caisseGest: string; // caisse dont dépend le patient
  centreGest: string; // centre dont dépend le patient
  identitePatient?: IdentitePatientApCV; // Identitié du Patient (INS, traits d'identitié,…)
}

export interface IdentitePatientApCV {
  INS?: string; // Numéro de sécurité social du patient + clé (INS-NIR)
  OID?: string; // Identifiant de l'organisme qui a affecté l'INS (INS-NIR : OID = 1.2.250.1.213.1.4.8)
  dateDebutINS?: string; // Date d'entrée en vigueur de l'INS
  dateFinINS?: string; // Date de fin de validité de l'INS
  nomNaissance?: string; // Nom de naissance. Cette donnée peut ne pas être renseignée
  prenomPatient?: string; // Liste des prénoms d'usage séparés par des espaces
  listePrenoms?: string; // Liste certifiante des prénoms d'état civil séparés par des espaces
  sexe?: string; // M : Masculine. F : Féminin. Cette donnée peut ne pas être renseignée.
  dateNaissancePatient?: string; // AAAAMMJJ Avec 1⇐MM⇐99 et 1⇐JJ⇐99
  lieuNaissance?: string; // Code sur 5 chiffres de la commune ou du pays de naissance du patient. Ce code est issu du Code Officiel Géographique (COG) de l’INSEE. Il ne s’agit pas du code postal de la commune de naissance du patient
}

// Fonction facturer

export class FactureFR {
  modeSecur: string = 'DEGRADE';
  topFactAMO: number = 1;
  topTpAMO: number = 1;
  topFactAMC: number = 1;
  topTpAMC: number = 1;
  topTpCoordonne: string = '';
  topForcageAT: string = '';
  dateRefAMC: string = '';
  PMSS?: number;
  dateFacture: string = '';
  numFacture: string = '';
  typeFluxCree: string = '';
  contexteAnonymisation: string = '';
  PS: PS;
  beneficiaire: BeneficiaireFact;
  prescription: Prescription;

  maladie?: Maladie; // Natures d'assurance
  maternite?: Maternite;
  accidentTravail?: AccidentTravail;
  smg?: SMG;

  PEC?: PEC; // Prise en chare AMC
  prestationFR: PrestationFR[];

  natureAssurance: string = 'maladie'; // Derived property. NOT SENT to Area but determines maladie OR maternité OR ...
  sn!: SituationNature; // Derived UNUSED. In case we need data attached to SituationNature later
  //accordEP?: string;											// Derived property. !! TOUTES les lignes LPP auront les mêmes data EP
  //dateDemandeEP?: string;

  totalFacture?: TotalFacture; // Output properties, not used in creating facture, filled by Area w/ "facturer"

  constructor(data: any) {
    //console.log(`[FactureFR constructor] input: ${JSON.stringify(data, null, 2)}`, "color: brown;");
    this.modeSecur = data.modeSecur;
    this.topFactAMO = data.topFactAMO;
    this.topTpAMO = data.topTpAMO;
    this.topFactAMC = data.topFactAMC;
    this.topTpAMC = data.topTpAMC;
    this.topTpCoordonne = data.topTpCoordonne;
    this.topForcageAT = data.topForcageAT;
    this.dateRefAMC = data.dateRefAMC;
    this.PMSS = data.PMSS;
    this.dateFacture = data.dateFacture;
    this.numFacture = data.numFacture;
    this.typeFluxCree = data.typeFluxCree;
    this.contexteAnonymisation = data.contexteAnonymisation;
    this.PS = data.PS ? new PS(data.PS) : PS.createDefault();
    this.beneficiaire = new BeneficiaireFact(data.beneficiaire);
    this.prescription = new Prescription(data.prescription);

    this.maladie = new Maladie(data.maladie);
    this.maternite = new Maternite(data.maternite);
    this.accidentTravail = new AccidentTravail(data.accidentTravail);
    this.smg = new SMG(data.smg);

    this.PEC = new PEC(data.PEC);

    this.prestationFR = data.prestationFR
      ? data.prestationFR
          .filter((item: any) => item.originePresta === 'PS') // Test EV95-7.02 Exclude prestations not coming from PS (made up by Area)
          .map((item: any) => new PrestationFR(item))
      : [];

    this.natureAssurance = data.natureAssurance;
    //console.log(`[FactureFR constructor] output: ${JSON.stringify(this, null, 2)}`, "color: brown;");
  }

  static createDefault(): FactureFR {
    return new FactureFR({
      modeSecur: 'SESAM_VITALE',
      topFactAMO: 1,
      topTpAMO: 1,
      topFactAMC: 0,
      topTpAMC: 0,
      topTpCoordonne: '',
      topForcageAT: '',
      dateRefAMC: '',
      PMSS: undefined,
      dateFacture: undefined,
      numFacture: '',
      typeFluxCree: '',
      contexteAnonymisation: '',
      PS: PS.createDefault(),
      beneficiaire: BeneficiaireFact.createDefault(),
      prescription: Prescription.createDefault(),

      maladie: Maladie.createDefault(), // Create each one, will keep only one in toOrderedObject()
      maternite: Maternite.createDefault(),
      accidentTravail: AccidentTravail.createDefault(),
      smg: SMG.createDefault(),

      PEC: PEC.createDefault(),
      prestationFR: undefined, // Will be turned into [] by the constructor

      natureAssurance: 'maladie',
      sn: undefined,
    });
  }

  toOrderedObject() {
    const obj = {
      modeSecur: this.modeSecur,
      topFactAMO: this.topFactAMO,
      topTpAMO: this.topTpAMO,
      topFactAMC: this.topFactAMC,
      topTpAMC: this.topTpAMC,
      topTpCoordonne: this.topTpCoordonne,
      topForcageAT: this.topForcageAT,
      //dateRefAMC: utils.tofseformat(this.dateRefAMC,)??'',
      dateRefAMC: '',
      PMSS: this.PMSS,
      dateFacture: tofseformat(this.dateFacture) ?? '',
      numFacture: this.numFacture,
      typeFluxCree: this.typeFluxCree, // Not included in xml input
      contexteAnonymisation: this.contexteAnonymisation,
      PS: this.PS.toOrderedObject(),
      beneficiaire: this.beneficiaire.toOrderedObject(this),
      prescription: this.prescription.toOrderedObject(this),
      maladie: this.natureAssurance == 'maladie' ? this.maladie?.toOrderedObject(this.beneficiaire.attestationAMO.pieceJustifAMO) : undefined,
      maternite: this.natureAssurance == 'maternite' ? this.maternite?.toOrderedObject(this) : undefined,
      accidentTravail: this.natureAssurance == 'accidentTravail' ? this.accidentTravail?.toOrderedObject() : undefined,
      SMG: this.natureAssurance == 'smg' ? this.smg?.toOrderedObject(this) : undefined,
      PEC: this.PEC ? this.PEC.toOrderedObject(this) : undefined,
      prestationFR: this.prestationFR.map(prestation => prestation.toOrderedObject(this)),
    };

    if (this.beneficiaire.dateFinMaterForcee && this.maternite?.dateMaternite) {
      // Test 3.102 Forçage date fin exonération maternité
      this.beneficiaire.dateFinMaterTheo = this.maternite?.dateMaternite;
    }

    if (this.beneficiaire.topVictimeAttentat == 1) {
      // [EV95]-3 Article L.115 "Attentat" pas de facturation AMC
      obj.topFactAMC = 0;
      obj.topTpAMC = 0;
    }
    //removeEmptyProperties(obj.beneficiaire, true);
    //removeEmptyProperties(obj, true);
    //console.log("[facturerFR.toOrderedObject] this.accidentTravail: " + ' - ' + JSON.stringify(this.accidentTravail, null, 2));
    //console.log("[facturerFR.toOrderedObject] this.natureAssurance - obj: " + this.natureAssurance + ' - ' + JSON.stringify(obj, null, 2));
    removeEmptyProperty(obj, 'topTpCoordonne');
    removeEmptyProperty(obj, 'topForcageAT');
    removeEmptyProperty(obj, 'dateRefAMC');
    removeEmptyProperty(obj, 'typeFluxCree'); // MUST  be excluded from xml input
    removeEmptyProperty(obj, 'contexteAnonymisation');
    removeEmptyProperty(obj, 'maladie');
    removeEmptyProperty(obj, 'maternite');
    removeEmptyProperty(obj, 'accidentTravail');
    removeEmptyProperty(obj, 'SMG');
    removeEmptyProperty(obj, 'PEC');
    return obj;
  }
}

export interface TotalFacture {
  nbPresta?: string;
  totalFacture?: string;
  totalParticipationAssure?: string;
  totalRemboursableAmo?: string;
  totalRemboursableAmc?: string;
}

export interface PSData {
  numSituation?: string;
  numIdentFact?: string;
  nom?: string;
  prenom?: string;
  codeConv?: string;
  spec?: string;
  zoneTarif?: string;
  zoneIK?: string;
  agr1?: string;
  agr2?: string;
  agr3?: string;
  condExercice?: string;
  typeIdentStruct?: string;
  numIdentStruct?: string;
  nomStruct?: string;
}

export class PS {
  numSituation?: string;
  numIdentFact?: string;
  nom?: string;
  prenom?: string;
  codeConv?: string;
  spec?: string;
  zoneTarif?: string;
  zoneIK?: string;
  agr1?: string;
  agr2?: string;
  agr3?: string;
  condExercice?: string;
  typeIdentStruct?: string;
  numIdentStruct?: string;
  nomStruct?: string;

  constructor(data: PSData) {
    //console.log('PSData constructor: ', JSON.stringify(data, null, 2));
    this.numSituation = data.numSituation;
    this.numIdentFact = data.numIdentFact;
    this.nom = data.nom;
    this.prenom = data.prenom;
    this.codeConv = data.codeConv;
    this.spec = data.spec;
    this.zoneTarif = data.zoneTarif;
    this.zoneIK = data.zoneIK;
    this.agr1 = data.agr1;
    this.agr2 = data.agr2;
    this.agr3 = data.agr3;
    this.condExercice = data.condExercice;
    this.typeIdentStruct = data.typeIdentStruct;
    this.numIdentStruct = data.numIdentStruct;
    this.nomStruct = data.nomStruct;
  }

  static createDefault(): PS {
    return new PS({
      numSituation: '',
      numIdentFact: '',
      nom: '',
      prenom: '',
      codeConv: '',
      spec: '',
      zoneTarif: '',
      zoneIK: '',
      agr1: '',
      agr2: '',
      agr3: '',
      condExercice: '',
      typeIdentStruct: '',
      numIdentStruct: '',
      nomStruct: '',
    });
  }

  toOrderedObject() {
    return {
      numSituation: this.numSituation,
      numIdentFact: this.numIdentFact,
      nom: this.nom,
      prenom: this.prenom,
      codeConv: this.codeConv,
      spec: this.spec,
      zoneTarif: this.zoneTarif,
      zoneIK: this.zoneIK,
      agr1: this.agr1,
      agr2: this.agr2,
      agr3: this.agr3,
      condExercice: this.condExercice,
      typeIdentStruct: this.typeIdentStruct,
      numIdentStruct: this.numIdentStruct,
      nomStruct: this.nomStruct,
    };
  }
}

export class BeneficiaireFact {
  typeIdentBenef: string = 'A';
  nom: string = '';
  prenom: string = '';
  numSecu: string = '';
  dateNaissBenef: string = '';
  rangNaiss: number = 1;
  qualite: number = 0;
  codeServiceAMO: string = '';
  codeALD: string = '0';
  codeSituation: string = '0000';
  cleLibelleTaux: string = '';
  dateFinMaterTheo: string = '';
  dateFinMaterForcee: string = '';
  topVictimeAttentat: number = 0;
  numSecuCertif: string = '';
  attestationAMO!: AttestationAMO;
  attestationAMC!: AttestationAMC;

  constructor(data: any) {
    this.typeIdentBenef = data.typeIdentBenef;
    this.nom = data.nom;
    this.prenom = data.prenom;
    this.numSecu = data.numSecu;
    this.dateNaissBenef = data.dateNaissBenef;
    this.rangNaiss = data.rangNaiss;
    this.qualite = data.qualite;
    this.codeServiceAMO = data.codeServiceAMO;
    this.codeALD = data.codeALD;
    this.codeSituation = data.codeSituation;
    this.cleLibelleTaux = data.cleLibelleTaux;
    this.dateFinMaterTheo = data.dateFinMaterTheo;
    this.dateFinMaterForcee = data.dateFinMaterForcee;
    this.topVictimeAttentat = data.topVictimeAttentat;
    this.numSecuCertif = data.numSecuCertif;
    this.attestationAMO = new AttestationAMO(data.attestationAMO);
    this.attestationAMC = new AttestationAMC(data.attestationAMC);
  }

  static fromEmpreinteCV(sns: SituationNatures, b: Beneficiaire, cv: EmpreinteCV, dat: Date): BeneficiaireFact {
    //console.log("[fromEmpreinteCV] Beneficiaire: " + JSON.stringify(b, null, 2));
    //console.log("[fromEmpreinteCV] EmpreinteCV: " + JSON.stringify(cv, null, 2));
    try {
      const newbf = new BeneficiaireFact({
        typeIdentBenef: cv.typeIdentPorteurCarte,
        nom: b.nomUsuel,
        prenom: b.prenom,
        numSecu: cv.numSecu,
        dateNaissBenef: getDateStringFromYYYYMMDD(b.dateNaissance),
        rangNaiss: b.rangNaissance,
        qualite: b.qualite,
        //codeServiceAMO: b.codeSrvAMOBenef??'00',	// Init w/ CV but defaults to 00 FIXME Should we use this as a default value?
        //codeServiceAMO: '00',
        codeServiceAMO: b.codeSrvAMOBenef ?? '00', // Test 1.17 Get from CV

        codeALD: '0', // WARNING Must be overloaded by b.periodeCodeCouverture at given date
        //codeSituation: getCodesituation(b, dat),	// Get codeSituation from periodeCodeCouverture and date
        codeSituation: '', // No codeSituation if CV

        cleLibelleTaux: '', // WARNING Special rules
        dateFinMaterTheo: '',
        dateFinMaterForcee: '',
        //topVictimeAttentat: (cv.codeGest==constants.VICTIME_ATTENTAT?1:0),  // Article L 115 en CV => cocher le forçage "Attentat" Test EV95-3
        topVictimeAttentat: 0, // Should be activated only by PS
        numSecuCertif: '',
        attestationAMO: new AttestationAMO({ regime: cv.codeRegime, caisseGest: cv.caisseGest, centreGest: cv.centreGest, pieceJustifAMO: PieceJustifAMO.CARTE_VITALE }), // Get data from CV header
        attestationAMC: AttestationAMC.fromBeneficiaire(sns, b, constants.TYP_PJ_AMO_CV),
      });
      return newbf;
    } catch (error) {
      console.error('Error fromBeneficiaire:', error);
      throw new Error('[fromBeneficiaire] error: ' + error);
    }
  }

  static fromEmpreinteADR(sns: SituationNatures, adr: EmpreinteAdr, dat: Date, pieceJustifAMO: PieceJustifAMO): BeneficiaireFact {
    try {
      const b = adr.beneficiaire;
      const newbf = new BeneficiaireFact({
        typeIdentBenef: 'A', // Valeur conventionnelle si non issue de la CV
        nom: b.nomUsuel ?? b.nomFamille,
        prenom: b.prenom,
        numSecu: adr.numSecu,
        dateNaissBenef: getDateStringFromYYYYMMDD(b.dateNaissance),
        rangNaiss: b.rangNaissance,
        qualite: b.qualite,
        codeServiceAMO: b.codeSrvAMOBenef ?? '00', // Init w/ ADRi but defaults to 00 FIXME Should we use this as a default value?
        //codeServiceAMO: '00',

        codeALD: '0', // WARNING Must be overloaded by b.periodeCodeCouverture at given date
        codeSituation: getCodesituation(b, dat), // Get codeSituation from periodeCodeCouverture and date

        cleLibelleTaux: '', // WARNING Special rules
        dateFinMaterTheo: '',
        dateFinMaterForcee: '',
        topVictimeAttentat: 0, // WARNING Potentiellement article L. 115 sur ADRi. Quel test ?
        numSecuCertif: '',
        attestationAMO: new AttestationAMO({ regime: adr.codeRegime, caisseGest: adr.caisseGest, centreGest: adr.centreGest, pieceJustifAMO: pieceJustifAMO }), // Get data from CV header
        attestationAMC: AttestationAMC.fromBeneficiaire(sns, b, constants.TYP_PJ_AMO_ADR),
      });
      return newbf;
    } catch (error) {
      console.error('Error fromBeneficiaire:', error);
      throw new Error('[fromBeneficiaire] error: ' + error);
    }
  }

  static createDefault(): BeneficiaireFact {
    return new BeneficiaireFact({
      typeIdentBenef: 'A',
      nom: '',
      prenom: '',
      numSecu: '',
      dateNaissBenef: '',
      rangNaiss: 1,
      qualite: 0,
      codeServiceAMO: '00',
      codeALD: '0',
      codeSituation: '0100',
      cleLibelleTaux: '',
      dateFinMaterTheo: '',
      dateFinMaterForcee: '',
      topVictimeAttentat: 0,
      numSecuCertif: '',
      attestationAMO: AttestationAMO.createDefault(),
      attestationAMC: AttestationAMC.createDefault(),
    });
  }

  toOrderedObject(f: FactureFR) {
    let attestationAMC: any | undefined;
    if (false && f.beneficiaire.codeServiceAMO == '01') {
      // Test [EV119] 21. codeServiceAMO == '01' => NO <attestationAMC> node. 04/26 REVERTED coz of ApCV sig 2.06
      attestationAMC = undefined;
    } else {
      attestationAMC = this.attestationAMC.toOrderedObject(f);
    }

    if (f.beneficiaire.topVictimeAttentat == 1) {
      // Test [EV95]-3 L'attentat annule l'attestation AMC. Gestion obligatoire en AMO SMG
      attestationAMC = undefined;
    }

    const obj = {
      typeIdentBenef: this.typeIdentBenef,
      nom: this.nom,
      prenom: this.prenom,
      numSecu: this.numSecu,
      dateNaissBenef: tofseformat(this.dateNaissBenef),
      rangNaiss: this.rangNaiss,
      qualite: this.qualite,
      codeServiceAMO: f.modeSecur === 'DEGRADE' ? '' : this.codeServiceAMO, // Send empty if DEGRADE
      codeALD: f.modeSecur === 'DEGRADE' ? '' : this.codeALD,
      //codeSituation: (f.modeSecur==='DEGRADE'?'':this.codeSituation),		// Send empty if DEGRADE !! WHY ??
      //codeSituation: this.codeSituation,		// Send empty if DEGRADE
      codeSituation: this.cleLibelleTaux ? '' : this.codeSituation, // Send empty if cleLibelleTaux is present
      cleLibelleTaux: this.cleLibelleTaux,
      dateFinMaterTheo: this.dateFinMaterTheo ? tofseformat(this.dateFinMaterTheo) : '',
      dateFinMaterForcee: this.dateFinMaterForcee ? tofseformat(this.dateFinMaterForcee) : '',

      topVictimeAttentat: this.topVictimeAttentat,
      numSecuCertif: this.numSecuCertif,
      attestationAMO: this.attestationAMO.toOrderedObject(),
      attestationAMC: attestationAMC,
    };
    //removeEmptyProperties(obj.attestationAMO, true);
    removeEmptyProperty(obj, 'codeServiceAMO');
    removeEmptyProperty(obj, 'codeALD');
    removeEmptyProperty(obj, 'codeSituation');
    removeEmptyProperty(obj, 'dateFinMaterTheo');
    removeEmptyProperty(obj, 'dateFinMaterForcee');
    removeEmptyProperty(obj, 'numSecuCertif');
    removeEmptyProperty(obj, 'cleLibelleTaux');
    removeEmptyProperty(obj, 'attestationAMC');
    removeEmptyProperty(obj, 'topVictimeAttentat');

    return obj;
  }
}

/**
 * Pièces justificatives AMO (AttestationAMO.pieceJustifAMO)
 *
 * Code de la pièce justificative présentée pour justifier les droits du bénéficiaire auprès de l'AMO :
 * - 0 : L'assuré n'a présenté aucune pièce justificative
 * - 1 : L'assuré a présenté un bulletin de salaire, une attestation de droits, une prise en charge pour l'AME, etc…
 * - 2 : L'assuré a présenté sa Carte d'assuré social (attestation AMO) ou le Professionnel de Santé a consulté le fichier patient par télématique (feu-vert, CDR, …)
 * - 4 : L'assuré a présenté sa carte Vitale
 * - A : Les droits ont été récupérés sur ADR
 * - E : ApCV, Application Carte Vitale + Droits ADRi
 */
export enum PieceJustifAMO {
  /** L'assuré n'a présenté aucune pièce justificative */
  AUCUNE = '0',
  /** L'assuré a présenté un bulletin de salaire, une attestation de droits, une prise en charge pour l'AME, etc… */
  ATTESTATION = '1',
  /** L'assuré a présenté sa Carte d'assuré social (attestation AMO) ou le Professionnel de Santé a consulté le fichier patient par télématique (feu-vert, CDR, …) */
  CARTE_ASSURE_SOCIAL = '2',
  /** L'assuré a présenté sa carte Vitale */
  CARTE_VITALE = '4',
  /** Les droits ont été récupérés sur ADR */
  ADR = 'A',
  /** ApCV, Application Carte Vitale + Droits ADRi */
  APCV = 'E',
}

export class AttestationAMO {
  regime: string = '';
  caisseGest: string = '';
  centreGest: string = '';
  pieceJustifAMO: PieceJustifAMO = PieceJustifAMO.AUCUNE;

  constructor(data: any) {
    this.regime = data.regime;
    this.caisseGest = data.caisseGest;
    this.centreGest = data.centreGest;
    this.pieceJustifAMO = data.pieceJustifAMO ?? PieceJustifAMO.AUCUNE;
  }

  static createDefault(): AttestationAMO {
    return new AttestationAMO({
      regime: '',
      caisseGest: '',
      centreGest: '',
      pieceJustifAMO: PieceJustifAMO.CARTE_VITALE,
    });
  }

  toOrderedObject() {
    return {
      regime: this.regime,
      caisseGest: this.caisseGest,
      centreGest: this.centreGest,
      pieceJustifAMO: this.pieceJustifAMO,
    };
  }
}

export class AttestationAMC {
  pieceJustifAMC: string = '';
  topGestionSeparee: string = '';
  typeAttestationParticuliere: string = 'AUCUNE';
  numAMC: string = '';
  mutnum: string = '';
  numEDI: string = '';
  typeConv: string = '';
  critSecondaire: string = '';
  garanties: string = '';
  numAdherent: string = '';
  idAssure: string = '';
  typeContrat: string = '';
  refusAMO: string = '';
  indicTrait: string = '';
  aiguillageSTS: string = '';
  codeRoutage: string = '';
  idHote: string = '';
  domaine: string = '';
  dateDebut: string = '';
  dateFin: string = '';
  idConvention: string = '';

  constructor(data: any) {
    this.pieceJustifAMC = data.pieceJustifAMC;
    this.topGestionSeparee = data.topGestionSeparee;
    this.typeAttestationParticuliere = data.typeAttestationParticuliere;
    this.numAMC = data.numAMC;
    this.mutnum = data.mutnum;
    this.numEDI = data.numEDI;
    this.typeConv = data.typeConv;
    this.critSecondaire = data.critSecondaire;
    this.garanties = data.garanties;
    this.numAdherent = data.numAdherent;
    this.idAssure = data.idAssure;
    this.typeContrat = data.typeContrat;
    this.refusAMO = data.refusAMO;
    this.indicTrait = data.indicTrait;
    this.aiguillageSTS = data.aiguillageSTS;
    this.codeRoutage = data.codeRoutage;
    this.idHote = data.idHote;
    this.domaine = data.domaine;
    this.dateDebut = data.dateDebut;
    this.dateFin = data.dateFin;
    this.idConvention = data.idConvention;
  }

  static createDefault(): AttestationAMC {
    return new AttestationAMC({
      pieceJustifAMC: '0',
      topGestionSeparee: '0',
      typeAttestationParticuliere: 'AUCUNE',
      numAMC: '',
      mutnum: '',
      numEDI: '',
      typeConv: '',
      critSecondaire: '',
      garanties: '',
      numAdherent: '',
      idAssure: '',
      typeContrat: '',
      refusAMO: '',
      indicTrait: '',
      aiguillageSTS: '',
      codeRoutage: '',
      idHote: '',
      domaine: '',
      dateDebut: '',
      dateFin: '',
      idConvention: '',
    });
  }

  static fromBeneficiaire(sns: SituationNatures, b: Beneficiaire, typ_pj_amo: number): AttestationAMC {
    console.log(`[AttestationAMC - fromBeneficiaire]\n${JSON.stringify(b, null, 2)}`);
    // Dates can come from either donneesAMC OR donneesMutuelle
    let dateDebut: string = '';
    let dateFin: string = '';
    let typeAttestationParticuliere = 'AUCUNE';
    if ((sns[typ_pj_amo].modeGestion == ModeGestion.GS || sns[typ_pj_amo].sp == SituationSpecifique.SP03d) && b.donneesAMC) {
      // Gestion S OR SP03d => dates in donneesAMC
      dateDebut = toFRformat(b.donneesAMC.dateDebut);
      dateFin = toFRformat(b.donneesAMC.dateFin);
    } else if (sns[typ_pj_amo].modeGestion == ModeGestion.GU) {
      // Gestion U => dates in donneesMutuelle
      if (b.donneesMutuelle) {
        console.log(`[AttestationAMC - fromBeneficiaire] Gestion unique w/ donneesMutuelle`);
        b.donneesMutuelle?.periodeMutuelle.forEach((pm: PeriodeMutuelle, _index) => {
          // Must get a valid one
          console.log(`[AttestationAMC - fromBeneficiaire] testing period ${JSON.stringify(pm, null, 2)}`);
          if (pm.active) {
            console.log(`[AttestationAMC - fromBeneficiaire] period is active!`);
            dateDebut = toFRformat(pm.dateDebut);
            dateFin = toFRformat(pm.dateFin);
          } else {
            console.log(`[AttestationAMC - fromBeneficiaire] period is inactive!`);
          }
        });
      } else {
        // Gestion U => NO DATES in donneesMutuelle (codeSrvAMOBenef==01) => dates are in periodeDroitsAMO
        console.log(`[AttestationAMC - fromBeneficiaire] Gestion unique without donneesMutuelle`);
        if (b.periodeDroitsAMO && sns[typ_pj_amo].activePeriodeAmoIndex) {
          dateDebut = toFRformat(b.periodeDroitsAMO[sns[typ_pj_amo].activePeriodeAmoIndex].dateDebut);
          dateFin = toFRformat(b.periodeDroitsAMO[sns[typ_pj_amo].activePeriodeAmoIndex].dateFin);
        } else {
          // Should NOT happen. dates are empty, will result in an error somehow
        }
      }
    }

    return new AttestationAMC({
      pieceJustifAMC: typ_pj_amo == constants.TYP_PJ_AMO_CV ? '4' : typ_pj_amo == constants.TYP_PJ_AMO_ADR ? 'A' : '0',
      topGestionSeparee: sns[typ_pj_amo].modeGestion == ModeGestion.GS ? '1' : '0',
      typeAttestationParticuliere: typeAttestationParticuliere,
      numAMC: b.donneesAMC?.numAMC,
      //mutnum: b.donneesMutuelle?.mutnum,
      mutnum: b.donneesMutuelle?.mutnum == '75500025' ? '75500017' : b.donneesMutuelle?.mutnum, // Test 5.16
      numEDI: b.donneesAMC?.numEDI,
      typeConv: '',
      critSecondaire: '',
      garanties: b.donneesMutuelle?.garanties,
      numAdherent: b.donneesAMC?.numAdherent,
      idAssure: '', // User input only
      // idAssure, typeContrat, refusAMO ??
      indicTrait: b.donneesMutuelle ? b.donneesMutuelle.indicTraitMutuelle : b.donneesAMC ? b.donneesAMC.indicTraitAMC : '',
      aiguillageSTS: b.donneesMutuelle ? b.donneesMutuelle.aiguillageSTS : b.donneesAMC ? b.donneesAMC.aiguillageSTS : '',
      codeRoutage: b.donneesAMC?.codeRoutage,
      idHote: b.donneesAMC?.idHote,
      domaine: b.donneesAMC?.domaine,
      dateDebut: dateDebut,
      dateFin: dateFin,
      idConvention: '',
    });
  }

  toOrderedObject(f: FactureFR): any {
    if (!this.numAMC && !this.mutnum) return undefined; // AttestationAMC should actually be undefined
    const obj = {
      pieceJustifAMC: this.pieceJustifAMC,
      topGestionSeparee: this.topGestionSeparee, // 0=gestion unique, 1=Gestion Séparée
      //typeAttestationParticuliere: constants.typeAttestationParticuliere[f.beneficiaire.codeServiceAMO],    // typeAttestationParticuliere is derived from codeServiceAMO (!) TODO Test all cases
      typeAttestationParticuliere: this.typeAttestationParticuliere,
      numAMC: this.numAMC, // SEPAREE
      mutnum: this.mutnum, // UNIQUE
      numEDI: this.numEDI, // SEPAREE
      typeConv: this.typeConv, // U/S
      critSecondaire: this.critSecondaire, // U/S TODO reg+cais+centre si absent de carte papier en GU, recopié de carte papier en GS
      garanties: this.garanties, // U
      numAdherent: this.numAdherent, // S
      idAssure: this.idAssure, // LG
      indicTrait: this.indicTrait, // U/S
      aiguillageSTS: this.aiguillageSTS, // U/S
      codeRoutage: this.codeRoutage, // S
      idHote: this.idHote, // S
      domaine: this.domaine, // S
      dateDebut: this.dateDebut, // U/S
      dateFin: this.dateFin, // U/S
      idConvention: this.idConvention,
    };
    obj.dateDebut = tofseformat(obj.dateDebut) ?? '';
    obj.dateFin = tofseformat(obj.dateFin) ?? '';
    if (obj.topGestionSeparee == '0') {
      // Gestion unique	=> empty S fields => will be removed
      //obj.numAMC='';	// Tests AV23 numAMC possible en GU (RO)
      obj.numEDI = '';
      obj.typeConv = ''; // Convention. RO en gestion unique
      obj.numAdherent = '';
      //obj.aiguillageSTS='';
      obj.codeRoutage = '';
      obj.idHote = '';
      obj.domaine = '';
      if (f.beneficiaire.attestationAMC.mutnum == '75500017') {
        // Cas part. AME en base
        obj.typeAttestationParticuliere = 'AME_BASE';
      }
    } else {
      // Use case S => empty U fields
      obj.mutnum = '';
      obj.garanties = '';
    }

    /*		if (f.beneficiaire.attestationAMC.mutnum == '88888888') {	// 1.16 Cas part. CMU_C (C2S) mutnum 88888 GU ou GS indter.
			obj.typeAttestationParticuliere = 'CMU_C';							// Set default typeAttestationParticuliere 
		}*/

    if (f.sn && f.sn.sp == SituationSpecifique.SP03d) {
    } // UNUSED

    removeEmptyProperty(obj, 'numAMC'); // Remove nullable fields
    removeEmptyProperty(obj, 'mutnum');
    removeEmptyProperty(obj, 'numEDI');
    removeEmptyProperty(obj, 'typeConv');
    removeEmptyProperty(obj, 'critSecondaire');
    removeEmptyProperty(obj, 'garanties');
    removeEmptyProperty(obj, 'numAdherent');
    removeEmptyProperty(obj, 'idAssure');
    removeEmptyProperty(obj, 'indicTrait');
    removeEmptyProperty(obj, 'aiguillageSTS');
    removeEmptyProperty(obj, 'codeRoutage');
    removeEmptyProperty(obj, 'idHote');
    removeEmptyProperty(obj, 'domaine');
    removeEmptyProperty(obj, 'dateDebut');
    removeEmptyProperty(obj, 'dateFin');
    removeEmptyProperty(obj, 'idConvention');
    return obj;
  }
}

export class Prescription {
  numIdentPresc: string = '';
  datePresc: string = '';
  codeSpecPresc: string = '';
  RPPSPresc: string = '';
  numStructPresc: string = '';
  typePresc: string = '';
  topPrescSNCF: string = '';
  originePrescription: string = 'I';

  constructor(data: any) {
    this.numIdentPresc = data.numIdentPresc;
    this.datePresc = tofseformat(data.datePresc);
    this.codeSpecPresc = data.codeSpecPresc;
    this.RPPSPresc = data.RPPSPresc;
    this.numStructPresc = data.numStructPresc;
    this.typePresc = data.typePresc;
    this.topPrescSNCF = data.topPrescSNCF;
    this.originePrescription = data.originePrescription;
  }

  static createDefault(): Prescription {
    return new Prescription({
      numIdentPresc: '',
      datePresc: '',
      codeSpecPresc: '',
      RPPSPresc: '',
      numStructPresc: '',
      typePresc: '',
      topPrescSNCF: '',
      originePrescription: 'I',
    });
  }

  toOrderedObject(_f: FactureFR) {
    const obj = {
      numIdentPresc: this.numIdentPresc,
      datePresc: this.datePresc,
      codeSpecPresc: this.codeSpecPresc,
      RPPSPresc: this.RPPSPresc,
      numStructPresc: this.numStructPresc,
      typePresc: this.typePresc,
      topPrescSNCF: this.topPrescSNCF,
      originePrescription: this.originePrescription,
    };
    //console.log('[Prescription.toOrderedObject], obj:', JSON.stringify(obj));
    removeEmptyProperty(obj, 'numIdentPresc');
    removeEmptyProperty(obj, 'RPPSPresc');
    removeEmptyProperty(obj, 'numStructPresc');
    removeEmptyProperty(obj, 'topPrescSNCF');
    removeEmptyProperty(obj, 'originePrescription');
    return obj;
  }
}

export class Maladie {
  topAccidentDroitCommun: number = 0; // 1 si accident de droit commun
  dateAccidentDroitCommun?: string; // date de l'accident
  topAlsaceMoselle: number | undefined = 0; // 1 si bénéficiaire régime Alsace Moselle, 0 sinon

  constructor(data: any) {
    this.topAccidentDroitCommun = data.topAccidentDroitCommun;
    this.dateAccidentDroitCommun = data.dateAccidentDroitCommun;
    this.topAlsaceMoselle = data.topAlsaceMoselle;
  }

  static createDefault(): Maladie {
    return new Maladie({
      topAccidentDroitCommun: 0,
      dateAccidentDroitCommun: '',
      topAlsaceMoselle: 0,
    });
  }

  static fromObject(obj: any): Maladie {
    return new Maladie({
      topAccidentDroitCommun: obj.topAccidentDroitCommun,
      dateAccidentDroitCommun: obj.dateAccidentDroitCommun,
      topAlsaceMoselle: obj.topAlsaceMoselle,
    });
  }

  toOrderedObject(pjAMO: PieceJustifAMO | string) {
    const obj = {
      topAccidentDroitCommun: this.topAccidentDroitCommun,
      dateAccidentDroitCommun: this.dateAccidentDroitCommun,
      topAlsaceMoselle: this.topAlsaceMoselle,
    };
    removeEmptyProperty(obj, 'dateAccidentDroitCommun');
    // Remove topAlsaceMoselle for specific AF types (CV, ADRi, ApCV)
    if ([PieceJustifAMO.CARTE_VITALE, PieceJustifAMO.ADR, PieceJustifAMO.APCV].includes(pjAMO as PieceJustifAMO)) {
      delete obj.topAlsaceMoselle;
    }
    return obj;
  }
}

export class Maternite {
  dateMaternite?: string; // Cette date correspond à la date présumée de grossesse ou à la date d’accouchement ou à la date d’adoption inscrite sur les étiquettes maternité.

  constructor(data: any) {
    this.dateMaternite = data.dateMaternite;
  }

  static createDefault(): Maternite {
    return new Maternite({
      dateMaternite: '',
    });
  }

  toOrderedObject(_f: FactureFR) {
    //console.log('[Maternite.toOrderedObject] this.dateMaternite: ', this.dateMaternite);
    const obj = {
      dateMaternite: this.dateMaternite,
    };
    return obj;
  }
}

export class AccidentTravail {
  orgaAT?: string; // organisme qui assure les AT du patient (=regime+caisse+centre)
  dateAT?: string; // date de l'AT
  numAT?: string; // numéro de l'AT
  topPECArmateur: number = 0; // pour régime 06 indique si l'armateur prend en charge l'accident
  topPresentationFAT: number = 0; // le bénéficiaire a présenté un feuillet AT (FAT)
  topPresenceOrgaATSupportHorsCV: number = 0; // le numéro orgaAT est-il présent sur un support autre que la CV (FAT, déclaration victime, attestation affiliation, courrier caisse)
  mtAPIAS?: number; // montant de la prise en charge au titre de l'APIAS

  oat: string; // Derived Origine AT : CV, FE (feuillet), ADR
  indexAT: number = 0; // Derived. Index of AT in CV: 0 (None) 1 or 2

  constructor(data: any) {
    this.oat = data.oat;
    this.orgaAT = data.orgaAT;
    this.dateAT = data.dateAT;
    this.numAT = data.numAT;
    this.topPECArmateur = data.topPECArmateur;
    this.topPresentationFAT = data.topPresentationFAT;
    this.topPresenceOrgaATSupportHorsCV = data.topPresenceOrgaATSupportHorsCV;
    this.mtAPIAS = data.mtAPIAS;
  }

  static createDefault(): AccidentTravail {
    return new AccidentTravail({
      oat: 'CV', // Init to CV
      orgaAT: '',
      dateAT: '',
      numAT: undefined,
      topPECArmateur: 0,
      topPresentationFAT: 0,
      topPresenceOrgaATSupportHorsCV: 0,
      mtAPIAS: undefined,
    });
  }

  static fromObject(obj: any): AccidentTravail {
    // Build instance from db object
    return new AccidentTravail({
      orgaAT: obj.orgaAT,
      dateAT: obj.dateAT,
      numAT: obj.numAT,
      topPECArmateur: obj.topPECArmateur,
      topPresentationFAT: obj.topPresentationFAT,
      topPresenceOrgaATSupportHorsCV: obj.topPresenceOrgaATSupportHorsCV,
      mtAPIAS: obj.mtAPIAS,
    });
  }

  toOrderedObject() {
    console.log(`[AccidentTravail.fromObject] ${this.orgaAT} - ${this.orgaAT?.slice(0, 2)}`);
    const obj = {
      orgaAT: this.orgaAT,
      dateAT: this.dateAT,
      numAT: this.orgaAT && this.orgaAT.slice(0, 2) == '01' ? this.numAT : '', // Renseigner numAT ONLY for régime général (01)
      topPECArmateur: this.topPECArmateur,
      topPresentationFAT: this.topPresentationFAT,
      topPresenceOrgaATSupportHorsCV: this.topPresenceOrgaATSupportHorsCV,
      mtAPIAS: this.mtAPIAS,
    };
    removeEmptyProperty(obj, 'numAT');
    //removeEmptyProperty(obj, 'topPECArmateur');
    removeEmptyProperty(obj, 'mtAPIAS');
    return obj;
  }
}

export class SMG {
  totalPEC?: number; // montant de la prise en charge au titre de la SMG

  constructor(data: any) {
    this.totalPEC = data.totalPEC;
  }

  static createDefault(): SMG {
    return new SMG({
      totalPEC: 0,
    });
  }

  toOrderedObject(_f: FactureFR) {
    //console.log('[SMG.toOrderedObject] this.totalPEC: ', this.totalPEC);
    const obj = {
      totalPEC: this.totalPEC,
    };
    return obj;
  }
}

export class PEC {
  refPEC: string = ''; // Référence de la prise en charge AMC
  montantPECAVentiler: number = 0;

  constructor(data: any) {
    this.refPEC = data.refPEC;
    this.montantPECAVentiler = data.montantPECAVentiler;
  }

  static createDefault(): PEC {
    return new PEC({
      refPEC: '',
      montantPECAVentiler: 0,
    });
  }

  toOrderedObject(_f: FactureFR) {
    const obj = {
      refPEC: this.refPEC,
      montantPECAVentiler: this.montantPECAVentiler,
    };
    if (!this.refPEC) return undefined;
    removeEmptyProperty(obj, 'montantPECAVentiler');
    return obj;
  }
}

export class PrestationFR {
  originePresta: string = 'PS'; // Input fields used to generate FactureFR
  dateExec?: string;
  topDomicile?: string;
  codePresta: string;
  montantHonoraires?: string;
  qualifDepense?: string = '';
  prixUnit?: string;
  codeJustifETM?: string;
  accordEP?: string;
  dateDemandeEP?: string;
  topPreventionCommuneAMOAMC?: string;
  LPP?: LPP;
  formulePrestaAMC?: FormulePrestaAMC;
  plafondCMU?: string; // Montant remb. max = fse_lpp.mntmax = MT_MAX

  coeff?: string; // Output fields, filled by "Facturer"
  montantRemboursementAMC?: string;
  montantRemboursementAMO?: string;
  quantite?: string;
  tauxRemboursementAMO?: string;
  typeNomenclature?: string;
  typePresta?: string;

  forcageAMO: string | undefined = undefined; // M : forcage montant, T : forcage Taux
  forcageAMC: boolean = false;

  constructor(data: any) {
    console.log(`%c[PrestationFR constructor] input: ${JSON.stringify(data, null, 2)}`, 'color: brown;');
    this.originePresta = data.originePresta;
    this.dateExec = data.dateExec;
    this.topDomicile = data.topDomicile;
    this.codePresta = data.codePresta;
    this.montantHonoraires = data.montantHonoraires;
    this.qualifDepense = data.qualifDepense;
    this.prixUnit = data.prixUnit;
    this.codeJustifETM = data.codeJustifETM;
    this.accordEP = data.accordEP;
    this.dateDemandeEP = data.dateDemandeEP;
    this.topPreventionCommuneAMOAMC = data.topPreventionCommuneAMOAMC;
    this.plafondCMU = data.plafondCMU; // Montant maximum de la prise en charge C2S pour cette prestation
    this.LPP = data.LPP ? new LPP(data.LPP) : undefined;
    this.formulePrestaAMC = data.formulePrestaAMC ? new FormulePrestaAMC(data.formulePrestaAMC) : undefined;

    this.montantRemboursementAMC = data.montantRemboursementAMC;
    this.montantRemboursementAMO = data.montantRemboursementAMO;
    this.tauxRemboursementAMO = data.tauxRemboursementAMO;
    console.log(`%c[PrestationFR constructor] output: ${JSON.stringify(data, null, 2)}`, 'color: brown;');
  }

  toOrderedObject(f: FactureFR): any {
    console.log('PrestationFR toOrderedObject - input prestation', JSON.stringify(this, null, 2));
    let codeJustifETM = this.codeJustifETM && this.codeJustifETM != '0' ? this.codeJustifETM : ''; // Removes '0's
    //if (f.beneficiaire.cleLibelleTaux && codeJustifETM == '5') { codeJustifETM = '' };	// codeJustifETM can't be 5 in input (possible in output though). Empty it when submiting w/cleLibelleTaux
    if (codeJustifETM == '5') {
      codeJustifETM = '';
    } // codeJustifETM can't be 5 on input (possible in output though). Empty it when submiting
    if (codeJustifETM == '9') {
      codeJustifETM = '';
    } // codeJustifETM can't be 9 (Fond Solid. vieill.) on input (possible in output though). Empty it when submiting
    if (codeJustifETM == '6') {
      codeJustifETM = '';
    } // codeJustifETM can't be 6 on input (possible in output though). Empty it when submiting
    const ame = f.beneficiaire.attestationAMC.mutnum == '75500017'; // CTF 2.20.01 + ADRi 5.16 ame détectée sur le MUTNUM
    //console.log("PrestationFR toOrderedObject - codeJustifETM", codeJustifETM);
    const obj: any = {
      originePresta: this.originePresta,
      dateExec: this.LPP?.typePrestaLPP === 'L' ? this.dateExec || tofseformat(f.dateRefAMC) : tofseformat(f.dateRefAMC) || this.dateExec, // Date de délivrance = date AMC = date premier acte (?)
      topDomicile: this.topDomicile,
      codePresta: this.codePresta,
      montantHonoraires: undefined, // Processed later, once LPP is loaded
      qualifDepense: this.qualifDepense,
      prixUnit: this.prixUnit,
      tauxRemboursementAMO: this.tauxRemboursementAMO,
      montantRemboursementAMO: this.montantRemboursementAMO,
      montantRemboursementAMC: this.montantRemboursementAMC,
      codeJustifETM: codeJustifETM,
      accordEP: this.accordEP,
      dateDemandeEP: this.dateDemandeEP,
      topPreventionCommuneAMOAMC: this.topPreventionCommuneAMOAMC,
      //plafondCMU: this.plafondCMU,
      plafondCMU: this.plafondCMU,
      LPP: this.LPP ? this.LPP.toOrderedObject(this) : undefined,
      formulePrestaAMC: this.formulePrestaAMC?.toOrderedObject(),
    };
    obj.qualifDepense = obj.qualifDepense?.replace('-', ''); // Remove - default value
    obj.montantHonoraires = +(this.LPP?.prixUnitairePublicLPP ?? 0) * +(this.LPP?.nbUnites ?? 0); //mtTotalTTC;                   // Only 1 LPP => montantHonoraires always mtTotalTTC
    if (ame && obj.qualifDepense != 'G') {
      // En AME les actes gratuits peuvent passer, ne pas forcer 'N'
      console.log('PrestationFR toOrderedObject - AME DETECTED');
      obj.qualifDepense = 'N'; // Force "Acte Gratuit"
    }
    if (obj.qualifDepense === 'G') {
      obj.montantHonoraires = '0';
    } // Acte gratuit => montant forcé à 0

    removeEmptyProperty(obj, 'qualifDepense');
    removeEmptyProperty(obj, 'codeJustifETM');
    removeEmptyProperty(obj, 'accordEP');
    removeEmptyProperty(obj, 'dateDemandeEP');
    removeEmptyProperty(obj, 'topPreventionCommuneAMOAMC');
    removeEmptyProperty(obj, 'plafondCMU');
    removeEmptyProperty(obj, 'formulePrestaAMC');
    removeEmptyProperty(obj, 'montantRemboursementAMC');
    removeEmptyProperty(obj, 'montantRemboursementAMO');
    removeEmptyProperty(obj, 'tauxRemboursementAMO');
    removeEmptyProperty(obj, 'LPP');

    //console.log("PrestationFR toOrderedObject - output prestation", JSON.stringify(obj, null, 2));
    return obj;
  }
}

export class LPP {
  codeLPP?: string;
  typePrestaLPP?: string;
  dateDebut?: string;
  dateFin?: string;
  tarifLPP?: string;
  nbUnites?: string;
  prixUnitairePublicLPP?: string;
  mtTotalLPP?: string;
  mtTotalTTC?: string;
  prixUnitaireReglemente?: string;

  constructor(data: any) {
    this.codeLPP = data.codeLPP;
    this.typePrestaLPP = data.typePrestaLPP;
    this.dateDebut = data.dateDebut;
    this.dateFin = data.dateFin;
    this.tarifLPP = data.tarifLPP;
    this.nbUnites = data.nbUnites;
    this.prixUnitairePublicLPP = data.prixUnitairePublicLPP;
    this.mtTotalLPP = data.mtTotalLPP;
    this.mtTotalTTC = data.mtTotalTTC;
    this.prixUnitaireReglemente = data.prixUnitaireReglemente;
  }

  toOrderedObject(prestationFR: PrestationFR) {
    let mtTotalTTC: number = +(this.prixUnitairePublicLPP ?? 0) * +(this.nbUnites ?? 0); // Test EV95-7.02 Overwrite it coz' simulation makes a mess w/ amounts
    const dateDebut = this.typePrestaLPP === 'L' ? this.dateDebut : prestationFR.dateExec || this.dateDebut;
    const dateFin = this.typePrestaLPP === 'L' ? this.dateFin : this.dateFin ? prestationFR.dateExec : this.dateFin;

    const obj: any = {
      codeLPP: this.codeLPP,
      typePrestaLPP: this.typePrestaLPP,
      dateDebut: dateDebut,
      dateFin: dateFin,
      tarifLPP: this.tarifLPP,
      nbUnites: this.nbUnites,
      //prixUnitairePublicLPP: prestationFR.montantHonoraires,	// Test EV95-7.02 Overwrite it coz' simulation makes a mess w/ amounts TODO Modified in getPrestationFRs. RETEST it
      prixUnitairePublicLPP: this.prixUnitairePublicLPP,
      mtTotalLPP: this.mtTotalLPP,
      mtTotalTTC: mtTotalTTC,
      prixUnitaireReglemente: this.prixUnitaireReglemente,
    };
    removeEmptyProperty(obj, 'codeLPP'); // Do not assign PA LPP
    removeEmptyProperty(obj, 'prixUnitaireReglemente');
    removeEmptyProperty(obj, 'dateFin');
    return obj;
  }
}

export class FormulePrestaAMC {
  idFormuleAMC?: string;
  paramFormuleAMC?: ParamFormuleAMC;

  constructor(data: any) {
    this.idFormuleAMC = data.idFormuleAMC;
    this.paramFormuleAMC = data?.paramFormuleAMC ? new ParamFormuleAMC(data.paramFormuleAMC) : undefined;
  }

  toOrderedObject() {
    const obj = {
      idFormuleAMC: this.idFormuleAMC,
      paramFormuleAMC: this.paramFormuleAMC?.toOrderedObject(),
    };
    removeEmptyProperty(obj, 'paramFormuleAMC');
    return obj;
  }
}

export class ParamFormuleAMC {
  idParam?: string;
  valeur?: string;

  constructor(data: any) {
    this.idParam = data.idParam;
    this.valeur = data.valeur;
  }

  toOrderedObject() {
    return {
      idParam: this.idParam,
      valeur: this.valeur,
    };
  }
}

// AF extraireFacturesJamaisMisesEnLot structures
export interface ListeLibellesTauxHTTPResponse {
  HTTPResponse: {
    codeRetour: string;
    libRetour: string;
    idSession: string;
    listeLibellesTaux: ListeLibellesTaux;
  };
}

export interface ListeLibellesTaux {
  libelleTaux: LibelleTaux[];
}

export interface LibelleTaux {
  cleLibelleTaux: string;
  libelle: string;
}

// AF recupererListeNirFictifs structures
export interface RecupererListeNirFictifsHTTPResponse {
  HTTPResponse: {
    codeRetour: string;
    libRetour: string;
    idSession: string;
    listeNirFictifs: ListeNirFictifs;
  };
}

export interface ListeNirFictifs {
  nirFictif: NirFictif[];
}

export interface NirFictif {
  patternNirFictif: string;
  codeJustifETM: string;
  modeSecur: string;
  dateNaiss: string;
  patternNumIdentPresc: string;
  commentaire: string;
}

export interface ConfigArea {
  // Interface representing the configuration parameters for AreaFSE API calls. (stored in station.configarea)
  area_baseurl: string;
  mode_appel_adri: string;
  nomRessLect: string; // “PCSC” ou “PC/SC” pour les lecteurs PC/SC.
  nomLogiciel: string; // Nom du logiciel autorisé à appeler ADR
  versionADR: string; // Version du logiciel autorisé à appeler ADR
  versionApCV: string; // Version du logiciel autorisé à appeler ApCV
  numAutorisationSocle: string; // N° autorisation du logiciel pour appeler le Socle FSE
  numAutorisationAdri: string; // N° autorisation du logiciel pour appeler ADRi
  numAutorisationApcv: string; // N° autorisation du logiciel pour appeler ApCV
  slotCPS?: string; // Nom du slot contenant la CPx en configuration PC/SC.
  slotVitale?: string; // Nom du slot contenant la Carte Vitale en configuration PC/SC.
  versionCommerciale: string; // Version commerciale du logiciel. Cette version peut être différente de versionApCV
  editeur: string;
  versionAnnuaireAMC: string;
  topSimulation: string;
  topSilencieux: string;
  PMSS: number;
}

// Helper function to remove empty properties from obj
function removeEmptyProperties(obj: any) {
  for (const key in obj) {
    //console.log("removeEmptyProperties obj/key: " + JSON.stringify(obj) + "/" + key);
    if (obj[key] && typeof obj[key] === 'object') {
      //console.log ("IS AN OBJECT")
      removeEmptyProperties(obj[key]);
      //console.log("nb properties: ", Object.keys(obj[key]).length);
      if (Object.keys(obj[key]).length == 0) delete obj[key];
    } else if (obj[key] === null || obj[key] === undefined || obj[key] === '' || (Array.isArray(obj[key]) && obj[key].length === 0)) {
      //console.log ("IS TO BE REMOVED nb prop left: " + Object.keys(obj).length);
      delete obj[key];
    }
    //console.log("removeEmptyProperties returning " + JSON.stringify(obj) + " - nb properties: " + Object.keys(obj).length);
  }
}

// Get a situation from array of periodeCodeCouverture matching date
function getCodesituation(b: Beneficiaire, d: Date): string {
  let ret = ''; // Default to 'pas d'éxonération' (?)
  if (!b?.periodeCodeCouverture) return ret;
  for (const [index, pc] of b.periodeCodeCouverture.entries()) {
    console.log('[getCodesituation] current periode:', JSON.stringify(pc, null, 2));
    if (isBlockActive(b.periodeCodeCouverture, index, d)) {
      ret = pc.codeSituation;
      break;
    }
  }
  /*	for (const c of b.periodeCodeCouverture) {	// TODO add date constraint
		console.log('[getCodesituation] periode:', JSON.stringify(c, null, 2));
		ret = c.codeSituation;
		break;
	}*/
  return ret;
}

/* WARNING cloned from state.service */
function isBlockActive(blocks: any, i: number, referenceDate: Date): boolean {
  let ret = false;
  if (!blocks || i < 0 || i >= blocks.length) {
    return false;
  } // Return false if the index is out of bounds

  const pc = blocks[i];
  const dateDebut = pc.dateDebut ? getDateFromYYYYMMDD(pc.dateDebut) : undefined;
  const dateFin = pc.dateFin ? getDateFromYYYYMMDD(pc.dateFin) : undefined;

  // Check if referenceDate is valid
  if (!referenceDate) {
    console.error(`Invalid reference date from dateFacture: ${referenceDate}. Returning false.`);
    return false;
  }

  // Check the conditions
  if (dateDebut && dateFin) {
    ret = referenceDate >= dateDebut && referenceDate <= dateFin;
  } else if (dateDebut && !dateFin) {
    ret = referenceDate >= dateDebut;
  } else if (!dateDebut && dateFin) {
    ret = referenceDate <= dateFin;
  } else if (!dateDebut && !dateFin) {
    ret = true;
  }
  console.log(`  [isBlockActive] index - active: ${i} - ${ret}`);
  return ret; // If both dateDebut and dateFin are undefined
}
